import React, { useState, useEffect } from 'react';
import Container from '../../Container/Container';
import { get } from '../../ApiServices/ApiServices';
import { useNavigate } from 'react-router-dom';
import Loader from '../Component/Loader';
import { useSelector } from 'react-redux';

function AccountDetail() {
    const [singleCustomers, setSingleCustomers] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);
    const profile = useSelector((state) => state.profile.profile);
    const navigate = useNavigate();

    const fetchCustomerProfile = async () => {
        if (!profile?.id) {
            setError('No profile ID available');
            setIsLoading(false);
            return;
        }

        try {
            setIsLoading(true);
            setError(null);
            const api = `view-customer/${profile.id}`;
            const response = await get(api);

            if (response?.status == true) {
                setSingleCustomers(response.data);
            } else {
                setError('Failed to fetch customer data');
            }
        } catch (err) {
            console.error('Error:', err);
            if (err?.message == "Invalid or expired token" || err?.message == "Invalid Token") {
                localStorage.removeItem('token');
                navigate('/login');
            } else {
                setError(err.message || 'An error occurred while fetching data');
            }
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchCustomerProfile();
    }, [profile?.id]); // Add dependency to re-fetch if profile ID changes

    if (isLoading) {
        return (
            <Container>

                <div className="nk-content">
                    <div className="container-fluid">
                        <div className="nk-content-inner">
                            <div className="nk-content-body">
                                <Loader />
                            </div>
                        </div>
                    </div>
                </div>
            </Container>

        );
    }

    if (error) {
        return (
            <>
                <Container>
                    <div className="nk-content">
                        <div className="container-fluid">
                            <div className="nk-content-inner">
                                <div className="nk-content-body">
                                    <div className="alert alert-danger">
                                        {error}
                                        <button
                                            className="btn btn-sm btn-outline-light ml-2"
                                            onClick={fetchCustomerProfile}
                                        >
                                            Retry
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </Container>
            </>

        );
    }

    const renderAddress = () => {
        if (!singleCustomers?.addresses?.[0]) return 'N/A';

        const address = singleCustomers.addresses[0];
        const parts = [
            address.billingAddress,
            address.billingCity,
            address.billingState,
            address.billingZip
        ].filter(Boolean);

        return parts.join(', ');
    };

    return (
        <Container>
            <div className="nk-content">
                <div className="container-fluid">
                    <div className="nk-content-inner">
                        <div className="nk-content-body">
                            <div className="nk-block-head nk-block-head-sm pbZeroHeadin">
                                <div className="nk-block-between">
                                    <div className="nk-block-head-content">
                                        <h3 className="nk-block-title page-title">Account Detail</h3>
                                    </div>
                                </div>
                            </div>

                            <div className="card card-full">
                                <div className="card-inner">
                                    <div className="card-title-group mb-4">
                                        <div className="card-title">
                                            <h6 className="title">Account Information</h6>
                                        </div>
                                    </div>

                                    <div className="row inputCardBox">
                                        <div className="col-md-6 mb-3">
                                            <div className="detailList">
                                                <span>Acct#:</span>
                                                <span className="wrap-text">{singleCustomers?.account || 'N/A'}</span>
                                            </div>
                                        </div>

                                        <div className="col-md-6 mb-3">
                                            <div className="detailList">
                                                <span>Company name:</span>
                                                <span className="wrap-text">{singleCustomers?.companyName || 'N/A'}</span>
                                            </div>
                                        </div>

                                        <div className="col-md-6 mb-3">
                                            <div className="detailList">
                                                <span>Phone:</span>
                                                <span className="wrap-text">{singleCustomers?.phone || 'N/A'}</span>
                                            </div>
                                        </div>

                                        <div className="col-md-6 mb-3">
                                            <div className="detailList">
                                                <span>Owner:</span>
                                                <span className="wrap-text">
                                                    {singleCustomers?.firstName || ''} {singleCustomers?.lastName || ''}
                                                </span>
                                            </div>
                                        </div>

                                        <div className="col-md-6 mb-3">
                                            <div className="detailList">
                                                <span>Billing Address:</span>
                                                <span className="wrap-text">
                                                    {renderAddress()}
                                                </span>
                                            </div>
                                        </div>

                                        <div className="col-md-6 mb-3">
                                            <div className="detailList">
                                                <span>Affiliated store:</span>
                                                <span className="wrap-text">{singleCustomers?.affiliatedStore || 'N/A'}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Container>
    );
}

export default AccountDetail;